/**
 * 建筑汇 breadcrumbs
 * 
 * @Author: Focci
 * @Date: 2023-06-21 10:25:33
 * @Last Modified by: Focci
 * @Last Modified time: 2023-06-21 10:25:33
 */

'use client'

import PropTypes from 'prop-types'
import Breadcrumbs from '@comp/Breadcrumbs'
import { useLocale, useTranslations } from 'next-intl'
import * as routePS from '@lib/route/productspec'

function ProductSpecBreadcrumbs({
  options = []
}) {
  const locale = useLocale()
  const tm = useTranslations('menu')

  const breadcrumbsOptions = [
    { label: tm('productspec'), url: routePS.home(locale) },
    ...options
  ]

  return (
    <Breadcrumbs options={breadcrumbsOptions} />
  )
}

ProductSpecBreadcrumbs.propTypes = {
  options: PropTypes.array,
}

export default ProductSpecBreadcrumbs
